import { PoolNumber } from "callable-data-objects";
import { MenuSearch } from "Components/Shared";
import DDIClassification from "Components/Shared/DDIClassification";
import { useNumberPool } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React from "react";
import { Breadcrumb, Button, Menu, Segment, Table } from "semantic-ui-react";

const GlobalNumberView = () => {
  const { ddis, search } = useNumberPool();
  return (
    <Segment>
      <Menu stackable>
        <Menu.Item header>
          <Breadcrumb>
            <Breadcrumb.Section>Inbound Numbers</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
        <Menu.Menu className='searchMenu'>
          <MenuSearch
            onSearch={search}
            placeholder='Search Numbers'
            value={search}
          />
        </Menu.Menu>
      </Menu>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Classification</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {ddis &&
            !isEmpty(ddis.content) &&
            ddis.content.map((gddi: PoolNumber) => (
              <Table.Row>
                <Table.Cell>{gddi.name}</Table.Cell>
                <Table.Cell>{gddi.type}</Table.Cell>
                <Table.Cell>
                  <DDIClassification classification={gddi.classification} />
                </Table.Cell>
                <Table.Cell>
                  <Button primary>View</Button>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </Segment>
  );
};

export default GlobalNumberView;
